module.exports = __webpack_public_path__ + "media/thumbnail.418a4f86.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/thumbnail.jpeg
// module id = ./src/templates/app-website/assets/thumbnail.jpeg
// module chunks = 0